import { createContext } from "react";

export const NavContext = createContext(false)